import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AccessRight } from '../../models';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccessRightService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  getAccessRights() {
    const route = `${this.configUrl}a/accessRights`;
    return this.http.get<Partial<AccessRight[]>>(route).pipe(
      map( (res) => res.map((a) => new AccessRight(a))),
    );
  }

  addAccessRight(newRight: AccessRight) {
    const route = `${this.configUrl}a/accessRight`;
    return this.http.post(route, {newRight}).pipe();
  }

  deleteAccessRight(toDeleteId: number) {
    const route = `${this.configUrl}a/accessRight/${toDeleteId}`;
    return this.http.delete(route).pipe();
  }
}
